<template>
  <consoHistory :title="$t('title.snacking')" :type-filter="typeFilter" />
</template>

<script>
import consoHistory from "@/components/pages/consoHistory";
import dimensionEnum from "@/model/dimensionEnum";
import { snackProductTypeEnum } from "@/model/businessEnum";
import { Snacking } from "@/router/routeNames";

export default {
  name: Snacking,
  components: {
    consoHistory,
  },
  data() {
    return {
      typeFilter: {
        dimension: dimensionEnum.SNACKPRODUCT_TYPE,
        operator: "equals",
        values: [snackProductTypeEnum.Snack.toString()],
      },
    };
  },
};
</script>
